export default "__VITE_ASSET__d68bb0b3__"